<template>
  <div class="home" :class="{ mobile: isM }">
    <div class="banner">
      <NavList :isM="isM" :isQa="isQa" />
      <h1>
        《仙境传说RO：新启航》官方网站 - 以神之名 一战封王<a
          href="https://ro.zlongame.com"
          target="_blank"
        ></a>
      </h1>
    </div>
    <div class="main">
      <Page1 :isM="isM" :isQa="isQa" />
      <Page2 :isM="isM" :isQa="isQa" />
      <Page3 :isM="isM" :isQa="isQa" />
    </div>
    <div class="footer">
      <Footer />
    </div>
  </div>
</template>

<script>
export default {
  components: {
    NavList: () => import("@/components/NavList"),
    Page1: () => import("@/components/Page1"),
    Page2: () => import("@/components/Page2"),
    Page3: () => import("@/components/Page3"),
    Footer: () => import("@/components/Footer"),
    Pop: () => import("@/components/Pop"),
  },
  props: {
    isM: Boolean,
    isQa: Boolean,
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>

<style lang="less" scoped>
.home {
  // width: 13.34rem;
  // height: 7.5rem;
  position: relative;
  overflow: hidden;

  .banner {
    height: 10.45rem;
    // background: url(https://media.zlongame.com/media/pictures/cn/ro/hd/2026/roxCompetitionS5/img/kv.webp)
    background: url(https://media.zlongame.com/media/pictures/cn/ro/hd/2026/roxCompetitionS5/img/kv.webp)
      no-repeat;
    background-size: cover;
    position: relative;

    h1 {
      font-size: 0;
    }

    a {
      position: absolute;
      top: 0.25rem;
      right: 0.3rem;
      display: block;
      width: 3.05rem;
      height: 1.3rem;
      // background: #00000033;
    }
  }

  .main {
    width: 100%;
    background: url(https://media.zlongame.com/media/pictures/cn/ro/hd/2026/roxCompetitionS5/img/bg1.webp)
      no-repeat;
    background-size: 100% 100%;
    padding-top: 1rem;
    padding-bottom: 1.45rem;
  }
}

.home.mobile {
  .banner {
    height: 13.3rem;
    background: url(https://media.zlongame.com/media/pictures/cn/ro/hd/2026/roxCompetitionS5/img/M/kv.webp)
      no-repeat;
    background-size: cover;

    a {
      top: 0.3rem;
      right: 50%;
      transform: translateX(50%);
      width: 3.2rem;
    }
  }

  .main {
    width: 100%;
    background: url(https://media.zlongame.com/media/pictures/cn/ro/hd/2026/roxCompetitionS5/img/M/bg1.webp)
      no-repeat;
    background-size: 100% 100%;
    padding-top: 0.5rem;
    padding-bottom: 1rem;
  }
}
</style>
